import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withXhr } from '@angular/common/http';
import localeEN from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { CamPwaService, PWA_CONFIG_KEY } from '@camelot/capacitor';
import { provideNotification } from '@camelot/notification';
import {
  CamServerModule,
  GRAPHQL_SERVER_CONFIG,
  SERVER_CONFIG_KEY,
  STRAPI_SERVER_CONFIG,
  TENANT_CONFIG_TOKEN,
} from '@camelot/server';
import { provideTranslation } from '@camelot/translation';
import { provideUser } from '@camelot/user';
import { APPLICATION_CONFIG, LOCAL } from '@camelot/utils';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { provideAzure } from './auth/azure.provider';
import { VisitorTokenService } from './auth/visitor-token.service';
import { VisitorInterceptor } from './auth/visitor.interceptor';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEN, 'en');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withXhr()),
    provideAnimations(),
    provideRouter(routes),
    importProvidersFrom(CamServerModule.forRoot({ config: environment.GRAPHQL_SERVER_CONFIG })),
    provideNotification(),
    provideUser(),
    importProvidersFrom(
      GoogleTagManagerModule.forRoot({
        id: environment.GTM,
      })
    ),
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: VisitorInterceptor,
    },
    // Instancié au démarrage : le graph service doit connaître la session visiteur avant la première requête.
    provideAppInitializer(() => {
      inject(VisitorTokenService);
    }),
    provideAzure(),
    provideTranslation({
      default: environment.TRANSLATION.DEFAULT,
      supportedLanguages: environment.TRANSLATION.SUPPORTEDLANGUAGES,
    }),
    {
      provide: TENANT_CONFIG_TOKEN,
      useValue: { tenantId: environment.TENANT_ID },
    },
    {
      provide: PWA_CONFIG_KEY,
      useValue: { active: environment.PWAACTIVE },
    },

    {
      provide: LOCAL,
      useValue: { isLocal: environment.LOCAL },
    },
    {
      provide: APPLICATION_CONFIG,
      useValue: { isCustomerApplication: environment.IS_CUSTOMER_APPLICATION },
    },
    {
      provide: GRAPHQL_SERVER_CONFIG,
      useValue: { config: environment.GRAPHQL_SERVER_CONFIG },
    },
    {
      provide: SERVER_CONFIG_KEY,
      useValue: { pendindRequestId: environment.PENDINGREQUESTAPI, serverUrl: environment.SERVER_URL },
    },
    {
      provide: STRAPI_SERVER_CONFIG,
      useValue: { config: environment.STRAPI_SERVER_CONFIG },
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    CamPwaService,
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.PWAACTIVE,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
